import React, { useState } from "react"
import { NumericFormat } from "react-number-format"
import Pagination from "./Pagination"
import { ReactComponent as Arrowright } from "../assets/images/ArrowRight.svg"
import Modal from "./Modal"
import DraggableModal from "./DraggableModal"
import InvoiceComponent from "./InvoiceComponent"
import GRN from "./GRN"
import { Link, useNavigate, useLocation } from "react-router-dom"
import formatText from "./formatText"

const TableComponent = ({
  data,
  recent_invoice,
  total,
  size,
  onButtonClick,
  count,
  page,
  complete,
  allInvoices,
  selectable = false,
  selectedIds = [],
  onToggleRow = () => {},
  onToggleAll = () => {},
}) => {
  const location = useLocation()
  const [expand, setExpand] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [isListVisible, setIsListVisible] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedInvoice, setSelectedInvoice] = useState(null)
  const [showDocuments, setShowDocuments] = useState(false)
  const [docsItem, setDocsItem] = useState(null)

  const handleStatus = item => {
    setIsListVisible(!isListVisible)
    setSelectedInvoice(item)
    setIsModalVisible(true)
    console.log(item, "item")
    console.log(isListVisible, "isListVisible")
    console.log(isModalVisible, "isModalVisible")
  }

  const handleCloseModal = () => {
    setIsModalVisible(false)
    setSelectedInvoice(null)
  }
  const handleCloseDocsLeft = () => {
    // close only left (Invoice) modal; if right is still open, keep background
    setDocsItem(prev => (prev ? { ...prev, _hideInvoice: true } : prev))
  }
  const handleCloseDocsRight = () => {
    setDocsItem(prev => (prev ? { ...prev, _hideGRN: true } : prev))
  }
  const handleCloseAllDocs = () => {
    setShowDocuments(false)
    setDocsItem(null)
  }
  const handleToggleList = item => {
    setSelectedItem(item)
    setIsListVisible(!isListVisible)
  }
  const handleViewDocuments = item => {
    console.log(item, "item")
    setDocsItem({ ...item, _hideInvoice: false, _hideGRN: false })
    setShowDocuments(true)
    setIsListVisible(false)
  }
  const convertDate = dateString => {
    if (!dateString) return "" // Return an empty string if dateString is null or undefined
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ]
    const [year, month, day] = dateString.split("-")
    const monthName = months[parseInt(month) - 1]
    const dayInt = parseInt(day)
    let suffix = "th"
    if (dayInt === 1 || dayInt === 21 || dayInt === 31) {
      suffix = "st"
    } else if (dayInt === 2 || dayInt === 22) {
      suffix = "nd"
    } else if (dayInt === 3 || dayInt === 23) {
      suffix = "rd"
    }
    return `${dayInt}${suffix} ${monthName}, ${year}`
  }

  const navigate = useNavigate()
  // Deprecated in favor of inline draggable modals
  const handleShowInvoice = data => {
    handleViewDocuments(data)
  }

  // Deprecated in favor of inline draggable modals
  const handleShowGRN = data => {
    handleViewDocuments(data)
  }

  const formatDateAndTime = timestamp => {
    const dateObj = new Date(timestamp)

    // Get day, month, and year
    const day = dateObj.getDate()
    const year = dateObj.getFullYear()

    // Get month names array
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ]
    const month = monthNames[dateObj.getMonth()] // Get month name

    // Add suffix for day (st, nd, rd, th)
    const daySuffix = day => {
      if (day > 3 && day < 21) return "th" // Special rule for 11th to 20th
      switch (day % 10) {
        case 1:
          return "st"
        case 2:
          return "nd"
        case 3:
          return "rd"
        default:
          return "th"
      }
    }

    // Format the date as '25th Aug, 2024'
    const date = `${day}${daySuffix(day)} ${month}, ${year}`

    // Format the time as 'HH:MM:SS'
    const time = dateObj.toTimeString().split(" ")[0]

    return { date, time }
  }

  const getLastDateSigned = signatures => {
    if (!signatures || signatures.length === 0) return null

    let lastDateSigned = null
    signatures.forEach(signature => {
      const dateSigned = new Date(signature.date_signed)
      if (!lastDateSigned || dateSigned > lastDateSigned) {
        lastDateSigned = dateSigned
      }
    })

    return lastDateSigned ? lastDateSigned.toISOString().split("T")[0] : null
  }
  const handleStatusChange = e => {
    const selectedStatus = e.target.value
    navigate(`/status/${selectedStatus}`)
  }

  const roles = JSON.parse(localStorage.getItem("roles")) || []
  const isAdmin = roles.includes("internal_control")

  const isRowEligible = item =>
    !item.workflow.completed && roles.includes(item.workflow?.pending_approval_from)
  const eligibleIds = (data || []).filter(isRowEligible).map(item => item.id)
  const allEligibleSelected =
    eligibleIds.length > 0 && eligibleIds.every(id => selectedIds.includes(id))

  return (
    <div className="table-container w-full bg-white rounded-xl flex flex-col">
      {/* Draggable side-by-side document modals */}
      {showDocuments && docsItem && (
        <>
          {!docsItem._hideInvoice && (
            <DraggableModal
              isVisible={true}
              onClose={handleCloseDocsLeft}
              title={"Invoice"}
              initialLeft={Math.max(16, Math.round(window.innerWidth * 0.03))}
              initialTop={24}
              width={Math.max(420, Math.round(window.innerWidth * 0.45))}
              style={{ border: "4px solid green" }}
            >
              <div className="p-2">
                <InvoiceComponent
                  Invoice={docsItem}
                  Colour={docsItem?.vendor?.vendor_settings?.invoice_color || "#3513f1"}
                />
              </div>
            </DraggableModal>
          )}
          {!docsItem._hideGRN && (
            <DraggableModal
              isVisible={true}
              onClose={handleCloseDocsRight}
              title={"GRN"}
              initialLeft={Math.max(24, Math.round(window.innerWidth * 0.52))}
              initialTop={24}
              width={Math.max(420, Math.round(window.innerWidth * 0.45))}
              style={{ border: "4px solid red" }}
            >
              <div className="p-2">
                {/* add the vendor object from the docsItem to the docs  */}
                <GRN
                  receipt={{
                    ...docsItem.grn,
                    vendor: docsItem.vendor,
                    workflow: docsItem.workflow,
                    invoice_line_items: docsItem.invoice_line_items,
                    invoice: docsItem,
                  }}
                />
              </div>
            </DraggableModal>
          )}
          {/* Close all button floating in corner when any is open */}
          <button
            type="button"
            className="fixed top-3 right-3 z-[70] text-xs bg-gray-800 text-white rounded px-3 py-1 hover:bg-gray-700"
            onClick={handleCloseAllDocs}
          >
            Close Documents
          </button>
        </>
      )}
      {/* End of Draggable side-by-side document modals */}
      {/* Modal for Invoice Approval Status */}
      <Modal isVisible={isModalVisible} onClose={handleCloseModal}>
        {selectedInvoice && (
          <div className="relative bg-white rounded-lg shadow ">
            {/* Modal header */}
            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t ">
              <h3 className="text-lg font-semibold text-gray-900 ">Invoice Approval Status</h3>
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={handleCloseModal}
              >
                <svg
                  className="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            {/* Modal body */}
            <div className="px-4 py-3">
              {selectedInvoice && (
                <>
                  <div className="p-4 ">
                    {selectedInvoice.workflow.signatories.length > 0 ? (
                      <ol className="relative border-s border-gray-200  mb-4">
                        {selectedInvoice.workflow.signatories.map((signatory, i) => {
                          const signature = selectedInvoice.workflow.signatures.find(
                            sig => sig.role === signatory,
                          )
                          const isCompleted = selectedInvoice.workflow.completed
                          const isApproved = signature?.approved

                          let status
                          if (isCompleted) {
                            if (signature) {
                              status = isApproved ? "Approved" : "Declined"
                            } else {
                              status = "N/A" // No signature available for this signatory
                            }
                          } else {
                            status = isApproved ? "Approved" : "Pending" // Default to 'Pending' if workflow is not completed
                          }
                          const dateSigned = signature?.date_signed
                            ? ` ${formatDateAndTime(signature.date_signed).date}`
                            : "" // Show date signed if available, otherwise "Not Signed"
                          const timeSigned = signature?.date_signed
                            ? ` ${formatDateAndTime(signature.date_signed).time}`
                            : "" // Show date signed if available, otherwise "Not Signed"
                          return (
                            <li className="mb-3 ms-4 w-full ">
                              <span className="absolute flex items-center justify-center w-6 h-6 bg-gray-100 rounded-full -start-3.5 ring-8 ring-white dark:ring-gray-700 dark:bg-gray-600">
                                <svg
                                  className="w-2.5 h-2.5 text-gray-500 dark:text-gray-400"
                                  aria-hidden="true"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M6 1a1 1 0 0 0-2 0h2ZM4 4a1 1 0 0 0 2 0H4Zm7-3a1 1 0 1 0-2 0h2ZM9 4a1 1 0 1 0 2 0H9Zm7-3a1 1 0 1 0-2 0h2Zm-2 3a1 1 0 1 0 2 0h-2ZM1 6a1 1 0 0 0 0 2V6Zm18 2a1 1 0 1 0 0-2v2ZM5 11v-1H4v1h1Zm0 .01H4v1h1v-1Zm.01 0v1h1v-1h-1Zm0-.01h1v-1h-1v1ZM10 11v-1H9v1h1Zm0 .01H9v1h1v-1Zm.01 0v1h1v-1h-1Zm0-.01h1v-1h-1v1ZM10 15v-1H9v1h1Zm0 .01H9v1h1v-1Zm.01 0v1h1v-1h-1Zm0-.01h1v-1h-1v1ZM15 15v-1h-1v1h1Zm0 .01h-1v1h1v-1Zm.01 0v1h1v-1h-1Zm0-.01h1v-1h-1v1ZM15 11v-1h-1v1h1Zm0 .01h-1v1h1v-1Zm.01 0v1h1v-1h-1Zm0-.01h1v-1h-1v1ZM5 15v-1H4v1h1Zm0 .01H4v1h1v-1Zm.01 0v1h1v-1h-1Zm0-.01h1v-1h-1v1ZM2 4h16V2H2v2Zm16 0h2a2 2 0 0 0-2-2v2Zm0 0v14h2V4h-2Zm0 14v2a2 2 0 0 0 2-2h-2Zm0 0H2v2h16v-2ZM2 18H0a2 2 0 0 0 2 2v-2Zm0 0V4H0v14h2ZM2 4V2a2 2 0 0 0-2 2h2Zm2-3v3h2V1H4Zm5 0v3h2V1H9Zm5 0v3h2V1h-2ZM1 8h18V6H1v2Zm3 3v.01h2V11H4Zm1 1.01h.01v-2H5v2Zm1.01-1V11h-2v.01h2Zm-1-1.01H5v2h.01v-2ZM9 11v.01h2V11H9Zm1 1.01h.01v-2H10v2Zm1.01-1V11h-2v.01h2Zm-1-1.01H10v2h.01v-2ZM9 15v.01h2V15H9Zm1 1.01h.01v-2H10v2Zm1.01-1V15h-2v.01h2Zm-1-1.01H10v2h.01v-2ZM14 15v.01h2V15h-2Zm1 1.01h.01v-2H15v2Zm1.01-1V15h-2v.01h2Zm-1-1.01H15v2h.01v-2ZM14 11v.01h2V11h-2Zm1 1.01h.01v-2H15v2Zm1.01-1V11h-2v.01h2Zm-1-1.01H15v2h.01v-2ZM4 15v.01h2V15H4Zm1 1.01h.01v-2H5v2Zm1.01-1V15h-2v.01h2Zm-1-1.01H5v2h.01v-2Z"
                                  />
                                </svg>
                              </span>
                              <div className="flex items-center justify-between ">
                                <h3 className=" mb-1 text-base font-semibold text-gray-900 dark:text-white ">
                                  {formatText(signatory)}
                                </h3>
                                <span
                                  className={` text-sm font-medium  px-2.5 py-0.5 rounded   border ${
                                    status === "Approved"
                                      ? "text-green-600 bg-green-100 border-green-300"
                                      : status === "Declined"
                                        ? "text-red-600 bg-red-100 border-red-300"
                                        : status === "N/A"
                                          ? "text-gray-600 bg-gray-100 border-gray-300"
                                          : "text-gray-600 bg-slate-50 border-gray-300"
                                  }`}
                                >
                                  {status}
                                </span>
                              </div>
                              <div className="flex gap-2 items-center">
                                <div className=" mb-3 text-sm leading-none text-gray-500 dark:text-gray-400">
                                  {dateSigned}
                                </div>

                                <div className=" mb-3 text-xs font-normal leading-none text-gray-500 dark:text-gray-400">
                                  {timeSigned}
                                </div>
                              </div>
                            </li>
                          )
                        })}
                      </ol>
                    ) : (
                      <div className="text-center">No Signatories</div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </Modal>
      {/* End of Modal for Invoice Approval Status */}
      {recent_invoice && (
        <>
          <p className="title-text font-semibold m-4">Recent Invoices Awaiting Approval</p>
        </>
      )}
      <div className="overflow-auto flex flex-col max-h-screen mx-4">
        <table className="md:w-full w-[1024px]">
          <thead className="bg-slate-50">
            <tr>
              {selectable && (
                <td className="pl-4 py-3 w-8">
                  {eligibleIds.length > 0 && (
                    <input
                      type="checkbox"
                      checked={allEligibleSelected}
                      onChange={() => onToggleAll(eligibleIds)}
                    />
                  )}
                </td>
              )}
              <td className="text-sm font-medium pl-4 py-3 text-gray-600">Date Created</td>
              <td className="text-sm font-medium pl-16 text-gray-600">Vendor</td>
              <td className="text-sm font-medium pl-4 text-gray-600">PO Number</td>
              <td className="text-sm font-medium pl-16 text-gray-600">GRN</td>
              <td className="grey-text text-sm font-medium text-gray-600  pl-20">Ref Number</td>
              <td className="grey-text text-sm font-medium text text-gray-600 pr-28 text-right">
                Amount (₦)
              </td>

              {recent_invoice === false && (
                <td className="text-sm font-medium  text-gray-600">Action</td>
              )}
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((item, index) => (
                <tr
                  key={index}
                  className={`text-sm border-b ${
                    !item.workflow.completed && roles.includes(item.workflow?.pending_approval_from)
                      ? "text-yellow-500"
                      : ""
                  }`}
                >
                  {selectable && (
                    <td className="pl-4 py-3">
                      {isRowEligible(item) && (
                        <input
                          type="checkbox"
                          checked={selectedIds.includes(item.id)}
                          onChange={() => onToggleRow(item.id)}
                        />
                      )}
                    </td>
                  )}
                  <td className="text-sm pl-4 py-3">
                    {/* {item?.workflow?.signatures?.length>0?convertDate((getLastDateSigned(item.workflow.signatures))):convertDate(item.due_date)} */}
                    {convertDate(item.date_created)}
                  </td>
                  <td className="text-sm  pl-16">
                    {item.vendor.vendor_name} ({item.vendor.byd_internal_id})
                  </td>
                  <td className="text-sm  pl-4">{item.grn.purchase_order.po_id}</td>
                  <td className="text-sm  pl-16">{item.grn.grn_number}</td>
                  <td className="grey-text text-sm  pl-20">{item.external_document_id}</td>
                  <td className="grey-text text-sm  pr-28 text-right">
                    <NumericFormat
                      value={item.gross_total}
                      displayType="text"
                      thousandSeparator={true}
                      decimalSeparator="."
                      decimalScale={2}
                      fixedDecimalScale
                    />
                  </td>

                  {recent_invoice === false && (
                    <td className="pr-2 lg:pr-4 text-center relative">
                      <button
                        id="benq-ex2710q-dropdown-button"
                        data-dropdown-toggle="benq-ex2710q-dropdown"
                        className="inline-flex items-center p-0.5 text-sm font-medium text-center text-gray-500 hover:text-gray-800 rounded-lg focus:outline-none "
                        type="button"
                        onClick={() => handleToggleList(item)}
                      >
                        <svg
                          className="w-5 h-5"
                          aria-hidden="true"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                        </svg>
                      </button>
                      {isListVisible && selectedItem === item && (
                        <div className="absolute  top-8 right-1 w-48 bg-white border border-gray-200 rounded-lg z-50">
                          <ul className="py-2 text-sm text-gray-700">
                            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                              <button
                                onClick={() => handleViewDocuments(item)}
                                className="block text-gray-700 no-underline no-decoration"
                              >
                                View Documents
                              </button>
                            </li>
                            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                              <button
                                onClick={() => handleStatus(item)}
                                className="block text-gray-700 no-underline no-decoration"
                              >
                                View Status
                              </button>
                            </li>
                            {!item.workflow.completed &&
                              roles.includes(item.workflow?.pending_approval_from) && (
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700 hover:text-gray-900"
                                  onClick={() => {
                                    onButtonClick(item)
                                    setIsListVisible(false)
                                  }}
                                >
                                  <button className="block">Approve/Decline</button>
                                </li>
                              )}
                          </ul>
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr className="w-full text-center">
                <td colSpan={selectable ? 9 : 8} className="py-4">
                  No Invoice found!
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {recent_invoice && data && data.length > 0 && (
          <div className="self-end flex gap-1 items-center my-4 mx-10">
            <span>See more</span>
            <Link to="/approval/pending">
              <Arrowright />
            </Link>
          </div>
        )}
        {!recent_invoice && data && data.length > 0 && (
          <Pagination totalPages={total} entriesPerPage={size} totalEntries={count} />
        )}

        {/* {recent_invoice===false&&filteredData && filteredData.length > 0 && (
					<div className="pagination-container flex justify-between mt-4 mb-5 px-3">
						<svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
																				<path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
																		</svg>
						<div>
							<label>Items per page:</label>
							<select className='mx-3 px-1 select-box' onChange={handleChangeItemsPerPage} value={itemsPerPage}>
							 
								<option value="5">5</option>
								<option value="10">10</option>
								<option value="15">15</option>
							</select>
						</div>
						<div className='flex items-center justify-between px-2'>
							<button onClick={handlePrevPage} disabled={currentPage === 1}>
								<Chevron_left className='bg-gray-100 rounded-md' />
							</button>
							<div className='px-2 -mt-1'>
								{currentPage}/{totalPages}
							</div>
							<button onClick={handleNextPage} disabled={currentPage === totalPages}>
								<Chevron_right className='bg-gray-100 rounded-md' />
							</button>
						</div>
					</div>
				)} */}
      </div>
    </div>
  )
}

export default TableComponent
